import { AppActionDefaultParams } from '@/h5/utils/appActions/constant'
import { isAndroid, isiOS } from '@/h5/utils/browserInfo'
import { cloneDeep } from 'lodash'
import UnityBridge from '@/h5/utils/appActions/unityBridge'
import ConfirmDialog from '@/h5/components/confirmDialog'
import Toast from '@/h5/components/toast'
import LGSdk from '@/packages/plugins/languageSDK/index'
import useAppStore from '@/h5/stores/app'
import { setParamsByDataSource } from '@/packages/plugins/hook/useDataSource'
import { getLanguage } from '@/packages/plugins/utils'

/**
 * app事件默认参数
 */
const getAppActionParams = (type, subValue, uid, pkgName) => {
  const data = AppActionDefaultParams[type] ? cloneDeep(AppActionDefaultParams[type]) : {}
  data.uid = uid
  if (type === '4') {
    let productId = isAndroid ? subValue.android : isiOS() ? subValue.iOS : ''
    // 获取当前包名的充值档位，如果没有则使用默认充值档位
    if (pkgName && subValue[pkgName]) {
      if (isAndroid && subValue[pkgName].android) {
        productId = subValue[pkgName].android
      } else if (!isAndroid && subValue[pkgName].iOS) {
        productId = subValue[pkgName].iOS
      }
    }
    // console.log('productId', productId, subValue)
    data.productId = productId
    data.activityId = subValue.activityId
  } else if (type === '5') {
    // console.log('subValue', subValue)
    if (!subValue?.activityId || !subValue?.currencyType || !subValue?.amount) {
      return null
    }
    data.activityId = subValue.activityId
    data.currencyType = subValue.currencyType
    data.amount = subValue.amount
  } else if (type === '6') {
    data.uid = subValue.uid
  } else if (type === '13') {
    data.uid = subValue.uid
    data.contentId = subValue.contentId
  } else if (type === '14') {
    data.topicsId = subValue.topicsId
  } else if (type === '17') {
    // 判断是否为"预览服饰页面"的事件, 是的话,将页面链接中的id赋值给params.data.activityId
    data.preViewGoodsId = subValue.preViewGoodsId
    data.preViewGoodsType = subValue.preViewGoodsType
    data.preViewShopType = subValue.preViewShopType
    data.previewPoolID = subValue.previewPoolID
    const currentUrl = new URL(window.location.href)
    let activityId = currentUrl.searchParams.get('id')
    if (activityId) {
      data.activityId = activityId
    }
  } else if (type === '19') {
    data.jumpId = subValue.jumpId
  }

  return data
}

const openUnityScene = (params) => {
  return new Promise((resolve, reject) => {
    UnityBridge.callHandler(`openScene&${JSON.stringify(params)}`, (_, data) => {
      console.log('openScene', _, data, params)
      if (_ === false || !data) {
        return reject(new Error('openScene error'))
      }
      if (params.type === 4) {
        // 拉起充值档位
        const res = JSON.parse(data)
        console.log('拉起充值档位', res)
        if (res && res.payResult === 1) {
          return resolve(true)
        }
      } else if (params.type === 5) {
        // 消耗金币
        const res = JSON.parse(data)
        if (res && res.currencyPayResult === 0) {
          // 支付失败
          Toast({ message: LGSdk.t('appSkipAction5.payFail'), duration: 1500 })
          return reject(new Error('currencyPayResult fail'))
        } else if (res && res.currencyPayResult === 1) {
          // 支付成功
          Toast({ message: LGSdk.t('appSkipAction5.paySuccess'), duration: 1500 })
          return resolve(true)
        } else if (res && res.currencyPayResult === 2) {
          // 购买失败 - 余额不足, 充值页面
          if (params.data.currencyType === 2) {
            // 钻石
            ConfirmDialog({
              title: LGSdk.t('appSkipAction5.tips'),
              message: LGSdk.t('appSkipAction5.currencyPayConfirmInfo'),
              confirmText: LGSdk.t('appSkipAction5.go'),
              cancelText: LGSdk.t('public.cancel')
            }).then(({ type }) => {
              if (type === 'confirm') {
                // 确定
                openUnityScene({ type: 2, data: params.data })
              }
            })
            return reject(new Error('currencyPayResult not sufficient funds (diamond)'))
          } else {
            // 金币
            Toast({ message: LGSdk.t('appSkipAction5.insufficientFunds'), duration: 1500 })
            return reject(new Error('currencyPayResult not sufficient funds'))
          }
        }
        return reject(new Error('currencyPayResult error'))
      } else {
        // 充值页面, 客态页面。。。页面跳转
        return resolve(true)
      }
    })
  })
}

export const handleAppActions = (value, subValue) => {
  return new Promise((resolve, reject) => {
    // 获取用户uid
    const appStore = useAppStore()
    const uid = appStore.uid
    const pkgName = appStore.pkgName
    const pageDataSource = appStore.pageDataSource
    if (!uid) {
      return reject(new Error('uid is empty'))
    }
    // 参数预处理
    if (value === '14') {
      // 跳转到话题详情页, 根据语言表示获取id
      try {
        const topicsData = JSON.parse(subValue.topicsId)
        const language = getLanguage()
        const topicsId = topicsData[language] || topicsData['en']
        if (topicsId) {
          subValue.topicsId = topicsId
        } else {
          return reject(new Error('topicsId is empty'))
        }
      } catch (error) {
        return reject(new Error('topicsId is empty error'))
      }
    } else if (value === '18') {
      // 房间内-送礼弹窗
      if (pageDataSource['data-source_inRoom']?.inRoom !== true) {
        // 不在房间内，展示固定多语言提示
        Toast({ message: LGSdk.t('appSkipAction18.notInRoom'), duration: 1500 })
        return reject(new Error('not in room'))
      }
    }
    // 获取app参数
    let data = getAppActionParams(value, subValue, uid, pkgName)
    data = setParamsByDataSource(data, pageDataSource)
    if (!data) {
      return reject(new Error('getAppActionParams error'))
    }
    const params = {
      type: Number(value),
      data
    }

    if (params.type === 5 && data.currencyType === 2) {
      // 消耗金币，钻石消耗类型为钻石弹框提示
      ConfirmDialog({
        title: LGSdk.t('appSkipAction5.tips'),
        message: LGSdk.t('appSkipAction5.buyConfirmInfo', { count: data.amount }),
        confirmText: LGSdk.t('public.confirm'),
        cancelText: LGSdk.t('public.cancel')
      }).then(({ type }) => {
        if (type === 'confirm') {
          // 确定
          openUnityScene(params)
            .then((res) => {
              return resolve(res)
            })
            .catch((err) => {
              return reject(err)
            })
        } else {
          // 取消
          return reject(new Error('dialogResult cancel'))
        }
      })
    } else {
      // console.log('params', params)
      // 调用app事件
      openUnityScene(params)
        .then((res) => {
          return resolve(res)
        })
        .catch((err) => {
          return reject(err)
        })
    }
  })
}

/**
 * 请求app事件
 * @param {*} appEventName app事件名称
 * @param {*} params app事件参数
 * @returns Promise
 */
export const requestAppEventApi = (appEventName, params) => {
  // 通过谷歌查询商品档位ID对应信息，查询档位参数特殊处理
  if (appEventName === 'getProductMessageByIds') {
    // 当前配置数据需特殊处理
    params = params.idConfigs
    const appStore = useAppStore()
    const pkgName = appStore.pkgName
    const androidIds = params.android.join(',')
    const iOSIds = params.iOS.join(',')
    const newParams = {}
    if (isAndroid) {
      newParams.ids = androidIds
    } else if (isiOS()) {
      newParams.ids = iOSIds
    }
    // 如果有配置当前包名的档位，则使用当前包名的档位
    if (pkgName && params[pkgName]) {
      if (isAndroid && params[pkgName].android?.length > 0) {
        newParams.ids = params[pkgName].android.join(',')
      } else if (isiOS() && params[pkgName].iOS?.length > 0) {
        newParams.ids = params[pkgName].iOS.join(',')
      }
    }
    params = newParams
  }
  return new Promise((resolve, reject) => {
    UnityBridge.callHandler(`${appEventName}&${JSON.stringify(params)}`, (_, data) => {
      console.log('requestAppEventApi', _, data, params)
      if (_ === false || !data) {
        return reject(new Error('requestAppEventApi error'))
      }
      const res = JSON.parse(data)
      if (res?.data?.status === 1) {
        return resolve({ ...res })
      } else {
        return reject(new Error('requestAppEventApi error'))
      }
    })
  })
}
